var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as moment from 'moment';
import { Loggeable } from '../../../../lib/common/loggeable.cls';
var FifoItemValidator = /** @class */ (function (_super) {
    __extends(FifoItemValidator, _super);
    /**
     * Contructor detail
     * save reference to provider
     * @param iProvider
     */
    function FifoItemValidator(iProvider) {
        var _this = _super.call(this) || this;
        /**
         * @Override
         *
         * validate a single cached item,
         * gets invoked by the ICache implementations
         * @param iCacheable the item to validate
         */
        _this.validate = function (iCacheable) {
            _this.log(FifoItemValidator.TAG, 'validate ', iCacheable);
            if ((iCacheable.maxAge + iCacheable.ts) <= _this.getNowMs()) {
                _this.iProvider.refresh(iCacheable);
            }
        };
        _this.iProvider = iProvider;
        return _this;
    }
    /**
     * @Override
     *
     * patch an expired item with new data
     * @param iCacheable the item to validate
     */
    FifoItemValidator.prototype.patchItem = function (oldItem, newItem) {
        var old = oldItem.item;
        var buy_increase_staus = 1;
        if (old.buy_increase_staus !== 'undefined') {
            buy_increase_staus = old.buy_increase_staus;
        }
        if (parseFloat(old.B) > parseFloat(newItem.B)) {
            buy_increase_staus = 0;
        }
        if (parseFloat(old.B) < parseFloat(newItem.B)) {
            buy_increase_staus = 1;
        }
        var sell_increase_staus = 1;
        if (old.sell_increase_staus !== 'undefined') {
            sell_increase_staus = old.sell_increase_staus;
        }
        if (parseFloat(old.A) > parseFloat(newItem.A)) {
            sell_increase_staus = 0;
        }
        if (parseFloat(old.A) < parseFloat(newItem.A)) {
            sell_increase_staus = 1;
        }
        newItem.A = parseFloat(newItem.A).toString();
        newItem.B = parseFloat(newItem.B).toString();
        newItem.SPREAD = ((parseFloat(newItem.A) - parseFloat(newItem.B)).toFixed(8)).toString();
        newItem.SPREAD = parseFloat(newItem.SPREAD).toString();
        newItem.buy_increase_staus = buy_increase_staus;
        newItem.sell_increase_staus = sell_increase_staus;
        oldItem.item = __assign({}, old, newItem);
    };
    // get current timestamp in milliseconds
    FifoItemValidator.prototype.getNowMs = function () {
        return moment().utc().valueOf();
    };
    // log tag
    FifoItemValidator.TAG = 'ItemValidator';
    return FifoItemValidator;
}(Loggeable));
export { FifoItemValidator };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/vue-provider-cache/provider/ws-price-feed/cache/fifo-item-validator.cls.ts
// module id = null
// module chunks = 